import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './css/Business.css';
import AromaticChemicalsImage from '../assets/images/SBU- Aromatic Chemicals & derivatives.jpg';
import HeatDissipationImage from '../assets/images/Heat Transfer Image-Nimble Technologies -1 (1).png';
import GreenMetalWorkingImage from '../assets/images/MWF Home Pagee- Green Metal Working Addtives .png';
import EcoFriendlyImage from '../assets/images/vertical 1.png';
import SEO from '../components/SEO';

const Business = () => {
  return (
    <>
      <SEO
        title="Business Verticals - Nimble Group Chemical Solutions"
        description="Explore Nimble Group's business verticals: Aromatic Chemicals, Heat Dissipation Compounds, Eco-Friendly Solutions, and Green Metal Working Additives. Leading sustainable chemical solutions."
        keywords="business verticals, aromatic chemicals, heat dissipation, eco-friendly solutions, green metal working, chemical manufacturing, sustainable solutions"
        canonical="/business"
      />
      <BusinessContent />
    </>
  );
};

const BusinessContent = () => {
  const businessVerticals = [
    { 
      title: 'Aromatic Chemicals & Derivatives',
      description: 'Crafting natural molecules for fragrances, flavors, and wellness. As a leading manufacturer of specialty aromatic chemicals, we supply high-quality ingredients to the fragrance, flavor, and pharmaceutical industries worldwide.',
      path: '/business/aromatic-chemicals',
      imageUrl: AromaticChemicalsImage
    },
    { 
      title: 'Heat Dissipation Compounds',
      description: 'Advanced thermal management solutions for electronics and industrial applications. Our nano-based heat sink compounds and thermal pastes improve heat transfer efficiency in LEDs, EVs, and power electronics, extending product lifespan and reliability.',
      path: '/business/heat-dissipation',
      imageUrl: HeatDissipationImage
    },
    { 
      title: 'Eco-Friendly & Sustainable Solutions',
      description: 'Innovative green products for a sustainable future. We develop high-performance, environmentally responsible alternatives to hazardous industrial chemicals, helping companies achieve sustainability goals while enhancing operational efficiency.',
      path: '/business/eco-friendly-solutions',
      imageUrl: EcoFriendlyImage
    },
    { 
      title: 'Green Metal Working Additives',
      description: 'Environmentally responsible additives for metalworking processes. Our biodegradable lubricity additives, boundary lubricants, and corrosion inhibitors enhance performance of metalworking fluids while reducing environmental impact.',
      path: '/business/green-metal-working',
      imageUrl: GreenMetalWorkingImage
    }
  ];

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  return (
    <div className="business-page">
      <motion.div 
        className="business-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container business-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Business Verticals
          </motion.h1>
          <div className="business-divider"></div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Explore our diverse range of industry-leading solutions built on decades of expertise, research, and a commitment to sustainable innovation
          </motion.p>
        </div>
      </motion.div>

      <motion.div 
        className="business-intro"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
      >
        <p className="content-justified">
          At Nimble Group, our business is built on creating value — not just for our customers, but for the environment and society at large. Each of our four strategic business verticals represents our dedication to excellence, sustainability, and innovative problem-solving across diverse industries.
        </p>
      </motion.div>

      <section className="business-verticals-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="section-title">Our Strategic Business Units</h2>
          </motion.div>

          <div className="business-grid">
            {businessVerticals.map((vertical, index) => (
              <motion.div
                key={vertical.title}
                className="business-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: index * 0.15 }}
              >
                <div className="business-card-image">
                  <img src={vertical.imageUrl} alt={vertical.title} />
                </div>
                <div className="business-card-content">
                  <h3>{vertical.title}</h3>
                  <p className="content-justified">{vertical.description}</p>
                  <Link to={vertical.path} className="business-card-link">
                    Learn More
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

            {/* CTA Section */}
            <section className="about-cta-section">
        <div className="about-cta-overlay"></div>
        <div className="container">
          <motion.div
            className="about-cta-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2>Ready to Explore Sustainable Solutions?</h2>
            <p>Discover how our green chemistry innovations can transform your business operations.</p>
            <motion.div whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(22, 163, 74, 0.3)" }} whileTap={{ scale: 0.95 }}>
              <Link to="/contact" className="about-cta-button">Contact Us Today</Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
export default Business; 